<template>
  <modal :is-active="isActive" @close="hide" :title="$t('configurator.modals.titles.edit_surface')">
    <template #body>
      <div class="form-horizontal">
        <div class="form-group">
          <label for="booth_refinement" class="control-label">
            {{ $t('configurator.form.labels.current_surface') }}
          </label>
          <div class="row">
            <div class="col-sm-12">
              <p style="padding-bottom: 0;">{{ currentRefinement }}</p>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="booth_refinement" class="control-label">
            {{ $t('configurator.form.labels.choose_surface') }}<span>*</span>:
          </label>
          <div v-if="refinement.booth_refinement.mandatory" class="row">
            <div class="col-sm-12">
              <p style="padding-bottom: 0;">
                {{ $t('configurator.labels.required_surface') }}
              </p>
            </div>
          </div>

          <div v-else class="row">
            <div v-if="filteredRefinements.length === 0" class="col-sm-12">
              <p style="padding-bottom: 0;">
                {{ $t('configurator.labels.no_alternative_surfaces') }}
              </p>
            </div>

            <div v-for="availableRefinement in filteredRefinements" class="col-sm-6" :key="availableRefinement.id">
              <div class="radio">
                <label>
                  <input
                    type="radio"
                    name="booth_refinement"
                    id="booth_refinement2"
                    :value="availableRefinement.id"
                    v-model="form.booth_refinement_id"
                    style="width: 13px" />
                  <p style="padding-bottom: 0;">{{ (inEnglish) ? availableRefinement.name_en : availableRefinement.name }}</p>
                </label>
              </div>
            </div>
          </div>
          <p v-if="form.errors.has('booth_refinement_id')" class="text-danger">
            {{ $t('configurator.form.errors.graphic_design') }}
          </p>
        </div>

        <div class="form-group text-center">
          <button type="button" class="btn btn-warning mr-2" @click.prevent="hide">
            {{ $t('configurator.buttons.cancel') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click.prevent="submit"
            :disabled="filteredRefinements.length === 0">
            {{ $t('configurator.buttons.update') }}
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import Form from '@/classes/Form'
import { useMainStore } from '@/store'
import { useCloudStore } from '@/stores/cloud'
import { computed, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { showErrorToast, showLoadingIndicator, showSuccessToast } from '@/utils/toast'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
const cloudStore = useCloudStore()
// define props
const props = defineProps({
  isActive: {
    type: Boolean,
    default: false,
  },
  refinement: {
    type: Object,
    required: true
  },
  isSeamlessPrint: {
    type: Boolean,
    default: false,
  },
  isGroup: {
    type: Boolean,
    default: false
  }
})
// define emits
const emit = defineEmits(['hide'])
// define reactive props
const form = reactive(new Form({
  booth_refinement_id: null
}))
// define computed props
const availableRefinements = computed(() => cloudStore.availableRefinements)
const inEnglish = computed(() => store.inEnglish)

const currentRefinement = computed(() => {
  return (inEnglish.value)
    ? props.refinement.booth_refinement.name_en
    : props.refinement.booth_refinement.name
})

const filteredRefinements = computed(() => {
  return availableRefinements.value.filter((availableRefinement) => {
    return availableRefinement.articles.reduce((a, b) => {
      if (b.article_id === props.refinement.article_id) {
        a++
      }

      return a
    }, 0) > 0
  })
})
// define methods
const hide = () => {
  emit('hide')
}

const submit = async () => {
  showLoadingIndicator(
    t('configurator.indicators.update_surface'),
    t('configurator.indicators.one_moment_please')
  )
  await cloudStore.changeBoothRefinement(form, props.refinement.id)
    .then(() => {
      showSuccessToast(t('configurator.toasts.messages.surface_updated'), t('toast.title.success'))
      hide()
    })
    .catch(() => showErrorToast(t('configurator.toasts.errors.surface_updated'), t('toast.title.error')))
}
</script>